// extracted by mini-css-extract-plugin
export default {"responseMessageRemark":"Remark_responseMessageRemark__QGio2","translationMissing":"Remark_translationMissing__qUuDB"};